import React from 'react'
import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react'
import { ChevronDownIcon } from 'lucide-react'

type SortByType =
  | ''
  | 'latest'
  | 'oldest'
  | 'most_view'
  | 'least_view'
  | 'high_watch'
  | 'low_watch'
  | 'high_coin'
  | 'low_coin'
  | 'most_like'
  | 'least_like'
  | 'least_comment'
  | 'most_comment'

type SortByFilterProps = {
  sortByType: SortByType
  setSortByType: React.Dispatch<React.SetStateAction<SortByType>>
  handleAllEarningsSortBy: (value: SortByType) => void
}

const SortByCreator: React.FC<SortByFilterProps> = ({
  sortByType,
  setSortByType,
  handleAllEarningsSortBy,
}) => {
  const iconSize = useBreakpointValue({ base: 10, sm: 20 })

  const handleMenuItemClick = (value: SortByType) => {
    setSortByType(value)
    handleAllEarningsSortBy(value)
  }

  return (
    <Flex className="gap-1 rounded-md border-2 border-[#D3D3D3] sm:gap-4">
      <Menu closeOnSelect={false} placement="bottom-end">
        <MenuButton
          as={Button}
          className="no-underline"
          minW={'auto'}
          maxH={'37px'}
          bg={'transparent'}
          rightIcon={<ChevronDownIcon height={iconSize} width={iconSize} />}
          pl={{ base: '5px !important', sm: '10px !important' }}
          pr={{ base: '1px !important', sm: '10px !important' }}
          color="#656565"
          _hover={{ bg: 'transparent' }}
          _active={{ bg: 'transparent' }}
          fontWeight="400"
          size={{ base: 'xs', sm: 'md' }}
        >
          Sort By
        </MenuButton>

        <MenuList zIndex="100 !important" className="px-2 text-black" py={2}>
          <Text className="ml-3 mt-2 font-semibold text-[#656565]">
            Upload Date
          </Text>
          <MenuItem
            py={1}
            bg={'transparent !important'}
            color={sortByType === 'latest' ? '#24BFA3' : '#9F9F9F'}
            _hover={{ bg: 'transparent' }}
            _active={{ color: '#24BFA3', bg: 'transparent' }}
            onClick={() => handleMenuItemClick('latest')}
          >
            Latest
          </MenuItem>
          <MenuItem
            py={1}
            bg={'transparent !important'}
            color={sortByType === 'oldest' ? '#24BFA3' : '#9F9F9F'}
            _hover={{ bg: 'transparent' }}
            _active={{ color: '#24BFA3', bg: 'transparent' }}
            onClick={() => handleMenuItemClick('oldest')}
          >
            Oldest
          </MenuItem>

          {/* <Text className="ml-3 mt-2 font-semibold text-[#656565]">
            Watchtime
          </Text>
          <MenuItem
            py={1}
            bg={'transparent !important'}
            color={sortByType === 'high_watch' ? '#24BFA3' : '#9F9F9F'}
            _hover={{ bg: 'transparent' }}
            _active={{ color: '#24BFA3', bg: 'transparent' }}
            onClick={() => handleMenuItemClick('high_watch')}
          >
            Highest Watchtime
          </MenuItem>
          <MenuItem
            py={1}
            bg={'transparent !important'}
            color={sortByType === 'low_watch' ? '#24BFA3' : '#9F9F9F'}
            _hover={{ bg: 'transparent' }}
            _active={{ color: '#24BFA3', bg: 'transparent' }}
            onClick={() => handleMenuItemClick('low_watch')}
          >
            Lowest Watchtime
          </MenuItem> */}

          <Text className="ml-3 mt-2 font-semibold text-[#656565]">
            {/* Earnings */}
            Watch Time Earnings (in LYK Coins)
          </Text>
          <MenuItem
            py={1}
            bg={'transparent !important'}
            color={sortByType === 'high_coin' ? '#24BFA3' : '#9F9F9F'}
            _hover={{ bg: 'transparent' }}
            _active={{ color: '#24BFA3', bg: 'transparent' }}
            onClick={() => handleMenuItemClick('high_coin')}
          >
            Highest LYK Coins
          </MenuItem>
          <MenuItem
            py={1}
            bg={'transparent !important'}
            color={sortByType === 'low_coin' ? '#24BFA3' : '#9F9F9F'}
            _hover={{ bg: 'transparent' }}
            _active={{ color: '#24BFA3', bg: 'transparent' }}
            onClick={() => handleMenuItemClick('low_coin')}
          >
            Lowest LYK Coins
          </MenuItem>

          <Text className="ml-3 mt-2 font-semibold text-[#656565]">Views</Text>
          <MenuItem
            py={1}
            bg={'transparent !important'}
            color={sortByType === 'most_view' ? '#24BFA3' : '#9F9F9F'}
            _hover={{ bg: 'transparent' }}
            _active={{ color: '#24BFA3', bg: 'transparent' }}
            onClick={() => handleMenuItemClick('most_view')}
          >
            Most Viewed
          </MenuItem>
          <MenuItem
            py={1}
            bg={'transparent !important'}
            color={sortByType === 'least_view' ? '#24BFA3' : '#9F9F9F'}
            _hover={{ bg: 'transparent' }}
            _active={{ color: '#24BFA3', bg: 'transparent' }}
            onClick={() => handleMenuItemClick('least_view')}
          >
            Least Viewed
          </MenuItem>

          <Text className="ml-3 mt-2 font-semibold text-[#656565]">
            Comments
          </Text>
          <MenuItem
            py={1}
            bg={'transparent !important'}
            color={sortByType === 'most_comment' ? '#24BFA3' : '#9F9F9F'}
            _hover={{ bg: 'transparent' }}
            _active={{ color: '#24BFA3', bg: 'transparent' }}
            onClick={() => handleMenuItemClick('most_comment')}
          >
            Most Comments
          </MenuItem>
          <MenuItem
            py={1}
            bg={'transparent !important'}
            color={sortByType === 'least_comment' ? '#24BFA3' : '#9F9F9F'}
            _hover={{ bg: 'transparent' }}
            _active={{ color: '#24BFA3', bg: 'transparent' }}
            onClick={() => handleMenuItemClick('least_comment')}
          >
            Least Comments
          </MenuItem>

          <Text className="ml-3 mt-2 font-semibold text-[#656565]">Likes</Text>
          <MenuItem
            py={1}
            bg={'transparent !important'}
            color={sortByType === 'most_like' ? '#24BFA3' : '#9F9F9F'}
            _hover={{ bg: 'transparent' }}
            _active={{ color: '#24BFA3', bg: 'transparent' }}
            onClick={() => handleMenuItemClick('most_like')}
          >
            Most Likes
          </MenuItem>
          <MenuItem
            py={1}
            bg={'transparent !important'}
            color={sortByType === 'least_like' ? '#24BFA3' : '#9F9F9F'}
            _hover={{ bg: 'transparent' }}
            _active={{ color: '#24BFA3', bg: 'transparent' }}
            onClick={() => handleMenuItemClick('least_like')}
          >
            Least Likes
          </MenuItem>
        </MenuList>
      </Menu>
    </Flex>
  )
}

export default SortByCreator
